import React, { useEffect, useState, useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import QRCodeStyling from 'qr-code-styling';
import api from '../../lib/api';
import './overlay.css';

export default function OverlayQR() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const [username, setUsername] = useState(null);
  const [loading, setLoading] = useState(true);
  const qrRef = useRef(null);
  const qrInstance = useRef(null);

  const accent = searchParams.get('accent') || '#FF6B35';
  const label = searchParams.get('label') || 'Support aku di sini!';
  const size = parseInt(searchParams.get('size') || '240');

  useEffect(() => {
    document.documentElement.classList.add('overlay-body');
    document.body.classList.add('overlay-body');
    return () => {
      document.documentElement.classList.remove('overlay-body');
      document.body.classList.remove('overlay-body');
    };
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await api.get(`/overlay/public/${token}`);
        setUsername(res.data.username);
      } catch (err) {
        console.error('Failed to fetch overlay user:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [token]);

  // Create & render QR once username is known
  useEffect(() => {
    if (!username || !qrRef.current) return;

    const profileUrl = `${window.location.origin}/u/${username}`;

    // High resolution for sharpness, then scale down via CSS if needed
    const renderSize = 1024; 

    const qr = new QRCodeStyling({
      width: renderSize,
      height: renderSize,
      type: 'svg', // Use SVG for perfect sharpness at any scale
      data: profileUrl,
      image: '/logo-favicon.png',
      margin: 12,
      qrOptions: {
        errorCorrectionLevel: 'H',
      },
      imageOptions: {
        crossOrigin: 'anonymous',
        margin: 8,
        imageSize: 0.7,
        hideBackgroundDots: true,
      },
      dotsOptions: {
        type: 'rounded',
        color: '#000000',
      },
      cornersSquareOptions: {
        type: 'extra-rounded',
        color: '#000000',
      },
      cornersDotOptions: {
        type: 'dot',
        color: '#000000',
      },
      backgroundOptions: {
        color: '#FFFFFF',
      },
    });

    // Clear previous
    qrRef.current.innerHTML = '';
    qr.append(qrRef.current);
    qrInstance.current = qr;
  }, [username, size]);

  if (loading) return null;
  if (!username) return null;

  return (
    <div className="qr-overlay-container" style={{ '--ov-accent': accent }}>
      <div className="qr-compact" style={{ '--qr-accent': accent, '--qr-size': `${size}px` }}>
        {/* Label */}
        <div className="qr-compact-label" style={{ background: accent }}>
          {label}
        </div>
        {/* QR Body */}
        <div className="qr-compact-body">
          <div ref={qrRef} className="qr-compact-canvas" />
        </div>
      </div>
    </div>
  );
}
